<template>
  <div class="animated fadeIn">
    <div v-if="!loading" class="row">

      <div class="col-12">
        <div class="card">
          <div class="card-header">
            Filtros de pedidos
          </div>
          <div class="card-body">
            <div class="row">

              <div class="col-12">
                <parameters-order-statuses
                  :parameter="parameter"
                ></parameters-order-statuses>
              </div>

              <div class="col-12 col-xl-6" v-for="operation in separationOperations" :key="'separation-operation-' + operation.value">
                <div class="card">
                  <div class="card-header">
                    Filtros para pedidos de {{ operation.label }} <span class="badge" :class="operationBadgeClassObject(operation.value)" >{{ operation.value }}</span>
                  </div>
                  <div class="card-body">
                    <div class="row px-md-0 px-3">

                      <div class="col-12 mb-0 mb-sm-3">
                        <pending-separation-filters
                          v-if="parameter.wmsOrderFilters"
                          :data="parameter.wmsOrderFilters.separation[operation.value].pending"
                          :type="operation.value"
                        ></pending-separation-filters>
                      </div>

                      <div class="col-12 col-sm-6 mt-3 mt-sm-0" v-if="operation.value === 'ENT'">
                        <label>Operação de Estoque:</label>
                        <multi-select :options="allocationFiscalOperationStockOptions"
                              :selected-options="selectedAllocationFiscalOperationStock"
                              @select="onSelectAllocationStockOption">
                        </multi-select>
                      </div>

                      <div class="col-12 col-sm-6 mt-3 mt-sm-0" v-if="operation.value === 'ENT'">
                        <label>Operação Efetiva:</label>
                        <multi-select :options="allocationFiscalOperationEffectiveOptions"
                              :selected-options="selectedAllocationFiscalOperationEffective"
                              @select="onSelectAllocationEffectiveOption">
                        </multi-select>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <order-type-specific-settings
          :parameter="parameter"
        ></order-type-specific-settings>
      </div>

      <div class="col-12 col-lg-6">
        <div class="card">
          <div class="card-header">
            Quantidades
          </div>
          <div class="card-body">

            <div class="row mb-3 px-md-0 px-3">
              <div class="col">

                <div class="px-md-0 px-3">
                  <label>Campo à ser usado como quantidade nas ordens de produção</label>
                  <model-list-select
                    :list="productionQuantityFieldOptions"
                    option-value="value"
                    option-text="label"
                    v-model="parameter.productionQuantityField"
                  />
                </div>

              </div>
            </div>

            <div class="row mb-3 px-md-0 px-3">
              <div class="col">

                <div class="px-md-0 px-3">
                  <label>Campo à ser usado como quantidade nos demais tipos de pedidos</label>
                  <model-list-select
                    :list="stockQuantityFields"
                    option-value="value"
                    option-text="label"
                    v-model="parameter.stockQuantityField"
                  />
                </div>

              </div>
            </div>

            <div class="row mb-3 px-md-0 px-3">
              <div class="col">

                <div class="px-md-0 px-3">
                  <label>Mostrar unidade do:</label>
                  <model-list-select
                    :list="stockUnitFields"
                    option-value="value"
                    option-text="label"
                    v-model="parameter.stockUnitField"
                  />
                </div>

              </div>
            </div>

          </div>
        </div>

        <div class="card">
          <div class="card-header">
            Itens
          </div>
          <div class="card-body">

            <div class="row px-md-0 px-3">
              <div class="col-auto pr-0">
                <b-form-checkbox v-model="parameter.itemAutomaticLotByDefault"></b-form-checkbox>
              </div>
              <div class="col pl-0">
                <label>Lote automático por padrão</label>
              </div>
              <div class="col-12 ml-lg-0 ml-3">
                <small class="text-muted">
                  Se marcado, quando um novo item for sincronizado ele será automaticamente marcado como lote automático.
                  Isso não interfere em itens existentes. Para marcar ou desmarcar o campo "Lote automático" dos itens existentes basta usar o menu de Itens do WMS.
                  Nele você pode marcar ou desmarcar o lote automático individualmente ou usar o botão "Alterar todos os itens desse filtro" dentro de "Filtros".
                </small>
              </div>
            </div>

            <div class="row px-md-0 px-3 mt-3">
              <div class="col-auto pr-0">
                <b-form-checkbox v-model="parameter.generateComponentOrderItems"></b-form-checkbox>
              </div>
              <div class="col pl-0">
                <label>Gerar itens componentes</label>
              </div>
              <div class="col-12 ml-lg-0 ml-3">
                <small class="text-muted">
                  Se marcado, quando um pedido for sincronizado com itens compostos o sistema irá gerar seus respectivos itens componentes para o pedido conforme a composição dos itens compostos
                </small>
              </div>
            </div>

          </div>
        </div>

        <div class="card">
          <div class="card-header">
            Unidades de medida dos volumes
          </div>
          <div class="card-body">
            <div class="row px-md-0 px-3">
              <div class="col">
                <b-form-group
                  label="Altura"
                  label-for="unitOfMeasurementVolumesHeight">
                  <b-form-input
                    id="unitOfMeasurementVolumesHeight"
                    type="text"
                    v-model="parameter.unitOfMeasurementVolumesHeight"/>
                </b-form-group>
              </div>
            </div>
            <div class="row px-md-0 px-3">
              <div class="col">
                <b-form-group
                  label="Largura"
                  label-for="unitOfMeasurementVolumesWidth">
                  <b-form-input
                    id="unitOfMeasurementVolumesWidth"
                    type="text"
                    v-model="parameter.unitOfMeasurementVolumesWidth"/>
                </b-form-group>
              </div>
            </div>
            <div class="row px-md-0 px-3">
              <div class="col">
                <b-form-group
                  label="Comprimento"
                  label-for="unitOfMeasurementVolumesLength">
                  <b-form-input
                    id="unitOfMeasurementVolumesLength"
                    type="text"
                    v-model="parameter.unitOfMeasurementVolumesLength"/>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            Auditoria
          </div>
          <div class="card-body">
            <div class="row px-md-0 px-3">
              <div class="col">
                <div class="row mb-3 px-md-0 px-3">
                  <div class="col-auto pr-0">
                    <b-form-checkbox v-model="parameter.entityChangeHistoryEnabled"></b-form-checkbox>
                  </div>
                  <div class="col pl-0">
                    <label>Habilitar histórico de alterações</label>
                  </div>
                  <div class="col-12 text-justify">
                    <small class="text-muted">
                      Se marcado, quando for feita uma alteração em uma tabela auditável (ex: pedidos), o sistema irá gravar no histórico dados sobre essa alteração (estado anterior, estado novo, campos alterados, sistema, usuário, etc.) para servir de auditoria e auxiliar a identificar problemas de sincronização e alterações indevidas
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            Leitura dos códigos de barra
          </div>
          <div class="card-body">
            <div class="px-md-0 px-3 mb-3">
              <label>Origem de código de barras do endereço</label>
              <model-list-select
                :list="locationPrintBarcodeOrigin"
                option-value="value"
                option-text="label"
                v-model="parameter.locationPrintBarcodeOrigin"
              />
            </div>
            <div class="px-md-0 px-3">
              <label>Método do leitura do código de barras</label>
              <model-list-select
                :list="barcodeReadMethods"
                option-value="value"
                option-text="label"
                v-model="parameter.barcodeReadMethod"
              />
              <small v-if="parameter.barcodeReadMethod === 'C'" class="text-muted">
                Pode não funcionar dependendo da qualidade da câmera e da imagem do código de barras
              </small>
            </div>

            <div class="row mt-3">
              <div class="col-auto pr-0 ml-md-0 ml-3">
                <b-form-checkbox v-model="parameter.autoOpenCamera"></b-form-checkbox>
              </div>
              <div class="col pl-0">
                <label>Abrir automaticamente a câmera</label>
              </div>
              <div class="col-12 ml-lg-0 ml-3">
                <small class="text-muted">
                  Aplicável ao utilizar a câmera do dispositivo como leitor. <br>
                  Se marcado, abre automáticamente a câmera em algumas situações, <br>
                  sem que haja a necessidade de clicar no respectivo botão para abrir a câmera.
                </small>
              </div>
            </div>

            <div v-if="parameter.wmsBarcodeOptions" class="row mt-3 px-md-0 px-3">
              <div class="col-12">
                <label class="mb-2">Tamanho do código de barras</label>
              </div>
              <!-- <div class="col-sm-6 col-12 mb-3">
                <b-form-group
                  label="Lote"
                  label-for="wmsBarcodeOptionsLotSize">
                  <b-form-input
                    id="wmsBarcodeOptionsLotSize"
                    type="number"
                    v-model.number="parameter.wmsBarcodeOptions.lotSize"/>
                </b-form-group>
              </div> -->
              <div class="col-sm-6 col-12 mb-3">
                <b-form-group
                  label="Item"
                  label-for="wmsBarcodeOptionsItemSize">
                  <b-form-input
                    id="wmsBarcodeOptionsItemSize"
                    type="number"
                    v-model.number="parameter.wmsBarcodeOptions.itemSize"/>
                </b-form-group>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            Counter
          </div>
          <div class="card-body">

            <div class="row mb-3 px-md-0 px-3">
              <div class="col-auto pr-0">
                <b-form-checkbox v-model="parameter.scheduleExpeditionAutomatically"></b-form-checkbox>
              </div>
              <div class="col pl-0">
                <label>Agendar conferência da expedição automaticamente após finalizar separação</label>
              </div>
            </div>

            <div class="row mb-3 px-md-0 px-3">
              <div class="col-auto pr-0">
                <b-form-checkbox v-model="parameter.useExpeditionConfirmation"></b-form-checkbox>
              </div>
              <div class="col pl-0">
                <label>Usar confirmação na expedição</label>
              </div>
              <div class="col-12">
                <small class="text-muted">
                  Quando a conferência for finalizada e estiver correta o pedido:<br>
                  - Se marcado: irá para a aba "Aguardando confirmação" antes de ser liberado.<br>
                  - Se desmarcado: será liberado direto.
                </small>
              </div>
            </div>

            <div class="row mb-3 px-md-0 px-3">
              <div class="col-auto pr-0">
                <b-form-checkbox v-model="parameter.counterImmediateFeedback"></b-form-checkbox>
              </div>
              <div class="col pl-0">
                <label>No counter ter o feedback imediato na conferência se está com ou não divergente.</label>
              </div>
            </div>

            <div class="row mb-3 px-md-0 px-3">
              <div class="col-auto pr-0">
                <b-form-checkbox v-model="parameter.replaceTotalVolumeQuantity"></b-form-checkbox>
              </div>
              <div class="col pl-0">
                <label>Substituir quantidade total de volumes</label>
              </div>
              <div class="col-12">
                <small class="text-muted">
                  Se marcado, quando um volume for adicionado, editado ou removido do counter o campo VENDA_VOLUMES_QUANTIDADE da venda (e consequentemente da nota) será substituído pelo total das quantidades dos volumes do counter
                </small>
              </div>
            </div>

            <div class="row mb-3 px-md-0 px-3">
              <div class="col-auto pr-0">
                <b-form-checkbox v-model="parameter.replaceTotalWeights"></b-form-checkbox>
              </div>
              <div class="col pl-0">
                <label>Substituir pesos totais</label>
              </div>
              <div class="col-12">
                <small class="text-muted">
                  Se marcado, quando um volume for adicionado, editado ou removido do counter o peso total (líquido e bruto) será substituído pelo total dos pesos dos volumes do counter
                </small>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

    <div class="row justify-content-end px-md-0 px-3" id="save-button-container">
      <div v-if="loading || saving" class="col-auto">
        <animation/>
      </div>
      <div v-if="!saving" class="col-auto">
        <button type="button" class="btn btn-lg btn-primary" @click="save">
          Salvar
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import { httpClient } from '@/service'
import Animation from '@/components/loaders/animation'
import { LoadingAnimation } from '@/components/loaders'
import { ModelListSelect } from 'vue-search-select'
import { MultiSelect } from 'vue-search-select'
import PendingSeparationFilters from '@/views/config/pending-separation-filters.vue'
import OrderTypeSpecificSettings from '@/views/config/order-type-specific-settings.vue'
import ParametersOrderStatuses from '@/views/config/parameters-order-statuses.vue'
import shared from '@/shared/shared';

export default {
  name: 'parameters',
  components: {
    Animation,
    LoadingAnimation,
    ModelListSelect,
    MultiSelect,
    PendingSeparationFilters,
    OrderTypeSpecificSettings,
    ParametersOrderStatuses
  },

  data() {
    return {
      parameter: {
        companyGroup: {},
        separationPendingStatus: {},
        separationStartedStatus: {},
        separationFinishedStatus: {},
        expeditionToBeScheduledStatus: {},
        expeditionFinishedStatus: {},
        allocationFiscalOperationStockOptions: [],
        allocationFiscalOperationEffectiveOptions: []
      },
      allocationFiscalOperationStockOptions: [
        {  text: 'Aumentar', value: 'A' },
        {  text: 'Diminuir', value: 'D' },
        {  text: 'Neutro', value: 'N' }
      ],
      allocationFiscalOperationEffectiveOptions: [
        {  text: 'Sim', value: 'S' },
        {  text: 'Não', value: 'N' }
      ],
      selectedAllocationFiscalOperationStock: [],
      selectedAllocationFiscalOperationEffective: [],
      saving: false,
      barcodeReadMethods: [
        { value: 'K', label: 'Teclado (Padrão)' },
        { value: 'C', label: 'Câmera' }
      ],
      locationPrintBarcodeOrigin: [
        { value: 'B', label: 'Código de barras (Padrão)' },
        { value: 'N', label: 'Nome do endereço' }
      ],
      productionQuantityFieldOptions: [
        { value: 'quantidadeProduzir', label: 'Quantidade a Produzir' },
        { value: 'quantidadeProduzido', label: 'Quantidade Produzido' }
      ],
      loading: true,
      stockQuantityFields: [
        { value: 'QUANTITY', label: 'Quantidade' },
        { value: 'MOVEMENT_QUANTITY', label: 'Quantidade Movimenta' }
      ],
      stockUnitFields: [
        { value: 'ITEM', label: 'Item' },
        { value: 'ORDER', label: 'Pedido' }
      ],
      separationOperations: [
        { value: 'ENT', label: 'Entrada' },
        { value: 'SAI', label: 'Saída' },
        { value: 'RAL', label: 'Realocação' },
        { value: 'AJU', label: 'Ajuste' },
        { value: 'TRANSFORMACAO', label: 'Transformação' }
      ]
    }
  },

  mounted() {
    this.$store.dispatch('app/changePage', { title:'Parâmetros', size: 3 });
    this.loadParameter();
  },

  methods: {
    loadParameter() {
      this.loading = true;
      httpClient
      .get(`${process.env.VUE_APP_API_URL}parameters`)
      .then(data => {
        this.loading = false;

        if (data.data.data && data.data.data.content && data.data.data.content.length) {
          this.parameter = this.setParameterDefaultFields(data.data.data.content[0]);
        }
      })
      .catch((error) => {
        this.loading = false;

        if (error.message) {
          this.$notify.error(error)
        }
      });
    },
    operationBadgeClassObject (key) {
      return shared.operationBadgeClassObject({
        fiscalOperation: {
          showType: key
        }
      });
    },
    onSelectAllocationStockOption (items) {
      this.selectedAllocationFiscalOperationStock = items
    },
    onSelectAllocationEffectiveOption (items) {
      this.selectedAllocationFiscalOperationEffective = items
    },
    setParameterDefaultFields(parameter) {
      if (!parameter.barcodeReadMethod) {
        parameter.barcodeReadMethod = 'K';
      }

      if (!parameter.wmsBarcodeOptions) {
        parameter.wmsBarcodeOptions = {
          lotSize: null,
          itemSize: null
        };
      } else {
        if (parameter.wmsBarcodeOptions.lotSize === undefined) {
          parameter.wmsBarcodeOptions.lotSize = null;
        }
        if (parameter.wmsBarcodeOptions.itemSize === undefined) {
          parameter.wmsBarcodeOptions.itemSize = null;
        }
      }

      if (!parameter.productionQuantityField) {
        parameter.productionQuantityField = this.productionQuantityFieldOptions[0].value;
      }

      if (!parameter.stockQuantityField) {
        parameter.stockQuantityField = this.stockQuantityFields[0].value;
      }

      if (!parameter.stockUnitField) {
        parameter.stockUnitField = this.stockUnitFields[0].value;
      }

      if (parameter.allocationFiscalOperationStockOptions) {
        try {
          this.selectedAllocationFiscalOperationStock = JSON.parse(parameter.allocationFiscalOperationStockOptions);
        } catch (e) {
          console.log(e);
        }
      }

      if (parameter.allocationFiscalOperationEffectiveOptions) {
        try {
          this.selectedAllocationFiscalOperationEffective = JSON.parse(parameter.allocationFiscalOperationEffectiveOptions);
        } catch (e) {
          console.log(e);
        }
      }

      return this.setDefaultWmsSyncValidations(
        this.setDefaultWmsOrderFilters(
          parameter
        )
      );
    },

    setDefaultWmsOrderFilters(parameter) {
      if (!parameter.wmsOrderFilters) {
        parameter.wmsOrderFilters = {};
      }

      if (!parameter.wmsOrderFilters.separation) {
        parameter.wmsOrderFilters.separation = {};
      }

      let pendingSeparationFieldNames = [
        'companies',
        'stockLocales',
        'fiscalOperations'
      ];

      this.separationOperations.forEach(operation => {
        let key = operation.value;

        if (!parameter.wmsOrderFilters.separation[key]) {
          parameter.wmsOrderFilters.separation[key] = {};
        }

        if (!parameter.wmsOrderFilters.separation[key].pending) {
          parameter.wmsOrderFilters.separation[key].pending = {};
        }

        pendingSeparationFieldNames.forEach(fieldName => {
          if (!parameter.wmsOrderFilters.separation[key].pending[fieldName]) {
            parameter.wmsOrderFilters.separation[key].pending[fieldName] = [];
          }
        });
      });

      return parameter;
    },

    setDefaultWmsSyncValidations(parameter) {
      if (!parameter.wmsSyncValidations) {
        parameter.wmsSyncValidations = {};
      }

      if (!parameter.wmsSyncValidations.PRODUCAO) {
        parameter.wmsSyncValidations.PRODUCAO = {};
      }

      if (!parameter.wmsSyncValidations.TRANSFORMACAO) {
        parameter.wmsSyncValidations.TRANSFORMACAO = {};
      }

      if (!parameter.wmsSyncValidations.TRANSFORMACAO.skipSyncSituations) {
        parameter.wmsSyncValidations.TRANSFORMACAO.skipSyncSituations = [ 'T' ].map(v => shared.TRANSFORMATION_SITUATIONS.find(ts => ts.value === v));
      }

      if (!parameter.wmsSyncValidations.TRANSFORMACAO.partialSyncSituations) {
        parameter.wmsSyncValidations.TRANSFORMACAO.partialSyncSituations = [ 'S' ].map(v => shared.TRANSFORMATION_SITUATIONS.find(ts => ts.value === v));
      }

      if (!parameter.wmsSyncValidations.TRANSFORMACAO.syncAsPending) {
        parameter.wmsSyncValidations.TRANSFORMACAO.syncAsPending = [];
      }

      if (!parameter.wmsSyncValidations.TRANSFORMACAO.syncAsNotReleased) {
        parameter.wmsSyncValidations.TRANSFORMACAO.syncAsNotReleased = [];
      }

      return parameter;
    },

    alwaysTrueFilterPredicate() {
      return true;
    },

    save() {
      //Para não substituir os campos que não são do wms ou counter
      let p = {
        id: this.parameter.id,
        separationAnalysisStatus: this.parameter.separationAnalysisStatus ? this.parameter.separationAnalysisStatus.value : undefined,
        separationPendingBatchPickingStatus: this.parameter.separationPendingBatchPickingStatus ? this.parameter.separationPendingBatchPickingStatus.value : undefined,
        separationPendingStatus: this.parameter.separationPendingStatus ? this.parameter.separationPendingStatus.value : undefined,
        separationStartedStatus: this.parameter.separationStartedStatus ? this.parameter.separationStartedStatus.value : undefined,
        separationFinishedStatus: this.parameter.separationFinishedStatus ? this.parameter.separationFinishedStatus.value : undefined,
        expeditionToBeScheduledStatus: this.parameter.expeditionToBeScheduledStatus ? this.parameter.expeditionToBeScheduledStatus.value : undefined,
        expeditionFinishedStatus: this.parameter.expeditionFinishedStatus ? this.parameter.expeditionFinishedStatus.value : undefined,
        scheduleExpeditionAutomatically: this.parameter.scheduleExpeditionAutomatically,
        counterImmediateFeedback: this.parameter.counterImmediateFeedback,
        unitOfMeasurementVolumesHeight: this.parameter.unitOfMeasurementVolumesHeight,
        unitOfMeasurementVolumesWidth: this.parameter.unitOfMeasurementVolumesWidth,
        unitOfMeasurementVolumesLength: this.parameter.unitOfMeasurementVolumesLength,
        allocationFiscalOperationStockOptions: JSON.stringify(this.selectedAllocationFiscalOperationStock),
        allocationFiscalOperationEffectiveOptions: JSON.stringify(this.selectedAllocationFiscalOperationEffective),
        active: true,
        barcodeReadMethod: this.parameter.barcodeReadMethod,
        autoOpenCamera: this.parameter.autoOpenCamera,
        disableLotCreation: this.parameter.disableLotCreation,
        productionQuantityField: this.parameter.productionQuantityField,
        useExpeditionConfirmation: this.parameter.useExpeditionConfirmation,
        finishSeparationWhenOrderIsReleased: this.parameter.finishSeparationWhenOrderIsReleased,
        finishExpeditionWhenOrderIsClosed: this.parameter.finishExpeditionWhenOrderIsClosed,
        cancelSeparationWhenOrderIsCancelled: this.parameter.cancelSeparationWhenOrderIsCancelled,
        itemAutomaticLotByDefault: this.parameter.itemAutomaticLotByDefault,
        replaceTotalVolumeQuantity: this.parameter.replaceTotalVolumeQuantity,
        replaceTotalWeights: this.parameter.replaceTotalWeights,
        generateComponentOrderItems: this.parameter.generateComponentOrderItems,
        stockQuantityField: this.parameter.stockQuantityField,
        stockUnitField: this.parameter.stockUnitField,
        locationPrintBarcodeOrigin: this.parameter.locationPrintBarcodeOrigin,
        wmsOrderFilters: this.parameter.wmsOrderFilters,
        wmsBarcodeOptions: this.parameter.wmsBarcodeOptions,
        wmsSyncValidations: this.parameter.wmsSyncValidations,
        immediateTransferInboundRelease: this.parameter.immediateTransferInboundRelease,
        entityChangeHistoryEnabled: this.parameter.entityChangeHistoryEnabled
      };

      if (p.wmsOrderFilters && p.wmsOrderFilters.separation) {
        let temp = p.wmsOrderFilters.separation;
        for (const key in temp) {
          if (key != 'ENT' && key != 'SAI' && temp[key].pending) {
            temp[key].pending = {
              deploymentDate: temp[key].pending.deploymentDate
            }
          }

        }
      }

      this.saving = true;
      httpClient
      .put(`${process.env.VUE_APP_API_URL}parameters`, p)
      .then(data => {
        this.saving = false;
        this.$notify.success('Salvo com sucesso');
        this.parameter = this.setParameterDefaultFields(data.data.data);
      })
      .catch((error) => {
        this.saving = false;

        if (error.message) {
          this.$notify.error(error)
        }
      });
    }
  }
}
</script>

<style scoped>
#save-button-container {
  position: fixed;
  bottom: 1.5rem;
  right: 3.5rem;
}
</style>
